// extracted by mini-css-extract-plugin
module.exports = {"item":"select-icd10_item__1RXv7","itemTitle":"select-icd10_itemTitle__3AtQ7","itemId":"select-icd10_itemId__30PGm"};